// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__qYbXY","content":"Dashboard_content__8390r","container":"Dashboard_container__AJMcC","title":"Dashboard_title__RUbrd","ani":"Dashboard_ani__PUa8Z"};